
export const BASE_URLS = {
  about: 'about',
  features: 'api/features',
  shpGroups: 'api/groups',
  messages: 'api/messages',
  users: 'api/users',
  userClasses: 'api/controller/validations/aud012',
  shpKeys: 'api/controller/validations/shp078',
  userFilters: 'api/controller/validations/stu023',
  configs: 'api/configurations',
  persons: 'api/persons',
  validations: 'api/controller/validations',
  ucxEntries: 'api/controller/ucx',
  shpEntries: 'api/controller/shpsetting',
  shpSettingsByKey: 'api/settings/prefix',
  myinfo: 'api/users/myself',
};

export const URLS = {
  help: 'https://resources.elluciancloud.com/csh?context=degree_works_documentation',
};

export const CONSTANTS = {
  // API Header
  httpMediaTypes: {
    about: 'application/vnd.hedtech.degreeworks.about.v1+json',
    plainText: 'text/plain',
    userType: 'application/vnd.hedtech.degreeworks.user.v1.hal+json',
    groupType: 'application/vnd.hedtech.degreeworks.group.v1.hal+json',
    configType: 'application/vnd.hedtech.degreeworks.configuration.v1.hal+json',
    configSpecType: 'application/vnd.hedtech.degreeworks.specification.v1.hal+json',
    ucxType: 'application/vnd.hedtech.degreeworks.ucx.v1.hal+json',
    shpType: 'application/vnd.hedtech.degreeworks.shpsetting.v1.hal+json',
  },
  notificationType: {
    error: 'error',
    success: 'success',
    warning: 'warning',
  },
  // General
  access: 'access',
  gridSpacing: 2,
  typeAheadWaitTime: 1200,
  typeAheadMinChars: 2,
  successNotificationTimeout: 5000,
  errorNotificationTimeout: 5000,
  addMode: 'ADD',
  editMode: 'EDIT',
  emptyCharacter: ' ',
  expireDateNever: 'never',
  dateMinYear: 1900,
  dateMaxYear: 2100,
  timeoutMin: '00',
  timeoutMax: '99',
  neverTimeout: '9999',
  dateFormatForApi: 'YYYY-MM-DD',
  dateFormatForApiV2: 'yyyy-MM-dd',
  dateFormatForUI: 'MMM dd, yyyy',
  // The special case is used in the Dates in the STU016 Degree Works Term Literals.
  dateFormatForUIyyyyMMdd: 'yyyyMMdd',
  dateTimeFormatForApi: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  dateTimeUtcTime: 'T00:00:00.000+00:00',
  pageSizes: [10, 20],
  blankSpace: ' ',
  returnAndNewLineChar: '\r\n',
  fieldTypes: {
    array: 'ARRAY',
    boolean: 'BOOLEAN',
    dateTime: 'DATE',
    number: 'NUMBER',
    object: 'OBJECT',
    string: 'STRING',
  },
  defaultFileExtension: '.txt',
  defaultFileName: 'dataFile',
  defaultFileType: 'text/plain;charset=utf-8',
  sortDirection: {
    asc: 'asc',
    desc: 'desc',
  },

  // Users
  userPageSize: 20,
  userDefaultSortColumn: 'name',
  userDefaultSortDirection: 'asc',
  personsDefaultSortColumn: 'name',
  personsDefaultSortDirection: 'asc',
  personsSearchWaitTime: 1200,
  userValidationMaxUsers: 999,

  // Groups
  groupPageSize: 20,
  groupDefaultSortColumn: 'key',
  groupDefaultSortDirection: 'asc',
  groupNameMaxChars: 8,
  groupDescriptionMaxChars: 30,
  groupsApiMaxSize: 999,

  // Configurations
  configPageSize: 20,
  configDefaultSortColumn: 'configurationKey',
  configDefaultSortDirection: 'asc',
  configFieldTypes: {
    number: 'NUMBER',
    yesNo: 'YN',
    bool: 'BOOLEAN',
    choice: 'CHOICE',
    date: 'DATE',
    ucx: 'UCX',
    freeText: 'FREE',
    textBlock: 'BLOCK',
  },
  booleanString: {
    true: 'true',
    false: 'false',
  },

  // UCX
  ucxTableDefaultSortColumn: 'key',
  ucxTableDefaultSortDirection: 'asc',
  ucxTablePageSize: 20,

  // SHP
  shpTableDefaultSortColumn: 'specification',
  shpTableDefaultSortDirection: 'asc',
};

// Tokens
export const TOKEN = {
  align: {
    bottom: 'bottom',
    center: 'center',
    left: 'left',
    right: 'right',
    top: 'top',
    middle: 'middle',
  },
  breaks: {
    breakWord: 'break-word',
    breakAll: 'break-all',
  },
  colors: {
    black: '#000000',
    borderColor: '#E0E0E0',
    inherit: 'inherit',
    transparent: 'transparent',
  },
  flex: 'flex',
  flexDirections: {
    rowReverse: 'row-reverse',
  },
  fixed: 'fixed',
  important: '!important',
  inherit: 'inherit',
  none: 'none',
  normal: 'normal',
  positions: {
    absolute: 'absolute',
  },
  size: {
    auto: 'auto',
    size0: '0',
    size0rem: '0rem',
    size0D2rem: '0.2rem',
    size0D625rem: '0.625rem',
    size0D75rem: '0.75rem',
    size1D25rem: '1.25rem',
    size5rem: '5rem',
    size6rem: '6rem',
    size10rem: '10rem',
    size12rem: '12rem',
    size15rem: '15rem',
    size25rem: '25rem',
    size26rem: '26rem',
    size1px: '1px',
    size100vh: '100vh',
    maximum: '100%',
  },
  solid: 'solid',
  unset: 'unset',
  visibility: {
    hidden: 'hidden',
  },
  wrap: 'wrap',
};

// SHP
export const SHP_SPECIFICATION_LIST = [
  {
    id: 'controller',
    value: 'controller',
  },
  {
    id: 'default',
    value: 'default',
  },
  {
    id: 'dashboard',
    value: 'dashboard',
  },
  {
    id: 'services',
    value: 'services',
  },
  {
    id: 'transit',
    value: 'transit',
  },
  {
    id: 'transitbe',
    value: 'transitbe',
  },
  {
    id: 'treqadmin',
    value: 'treqadmin',
  },
  {
    id: 'treqss',
    value: 'treqss',
  },
];

export const SECURITY_ACCESS_ROLES = {
  CONFIGURATION: 'ROLE_CTLCONF',
  DEBUG: 'ROLE_DEBUG',
  GROUPS: 'ROLE_CTLGROUP',
  PROPERTIES: 'ROLE_CTLPROP',
  SCRIBE: 'ROLE_SCRIBE',
  USERS: 'ROLE_CTLUSERS',
};

/**
 * NOTE- Please do not change the order!.
 * Array of all modules of controller applications.
 * @returns {object[]} array of object that contains the module definition
 */
export const MODULES = [
  {
    id: 'home',
    active: true,
    label: 'controller.menu.home',
    securityRoles: [],
    description: undefined,
    uri: '/',
    iconType: undefined,
  },
  {
    id: 'authorization',
    active: false,
    label: 'controller.menu.authorization',
    securityRoles: [SECURITY_ACCESS_ROLES.GROUPS, SECURITY_ACCESS_ROLES.USERS],
    description: 'controller.home.authorization.description',
    uri: '/authorization',
    iconType: 'check-feedback',
  },
  {
    id: 'configuration',
    active: false,
    label: 'controller.menu.configuration',
    securityRoles: [SECURITY_ACCESS_ROLES.CONFIGURATION],
    description: 'controller.home.configuration.description',
    uri: '/configuration',
    iconType: 'settings',
  },
  {
    id: 'properties',
    active: false,
    label: 'controller.menu.properties',
    securityRoles: [SECURITY_ACCESS_ROLES.PROPERTIES],
    description: 'controller.home.properties.description',
    uri: '/properties',
    iconType: 'folder-open',
  },
  {
    id: 'scribe',
    active: false,
    label: 'controller.menu.scribe',
    securityRoles: [SECURITY_ACCESS_ROLES.SCRIBE],
    description: 'controller.home.scribe.description',
    uri: '/scribe',
    iconType: 'file-text',
  },
];

export const Endpoint = () => (window).location.href;

/**
 * The data picker component's popover element properties.
 */
export const datePickerPopover = {
  popperProps: {
    disablePortal: false,
    modifiers: [
      {
        name: 'preventOverflow',
        options: {
          enabled: true,
          boundariesElement: 'viewport',
        },
      },
    ],
  },
};
